import { httpClient } from "@/services";

export default {
	state: {

	},
	mutations: {

	},
	actions: {
		async getAccountDayChatNote({ dispatch }, values) {
			try {
				dispatch('actionPreloader', true);
				await httpClient.post('info/notes', values);
				dispatch('setAlert', { type: "success", message: "📤 Message has been sent successfully." });
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getAccountDaySick({ dispatch }, values) {
			try {
				dispatch('actionPreloader', true);
				const { date, id } = values;
				await httpClient.post(`info/users/sick/${ date }/${ id }`, values);
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {

	}
};
